<div class="as-modal-container">
    <p>Para cubrir variaciones de precios en tienda, tu pago en línea será de un 10% adicional a lo correspondiente a tu
        carrito actual. El cobro final será el que se haga en tienda el día de tu entrega.</p>
    <div class="btn-container">
        <button mat-stroked-button color="accent" (click)="closeModal(false)">{{ 'STORES.cancel' | translate }}</button>
        <button mat-flat-button color="accent" (click)="closeModal(true)">{{ 'GENERAL.continue' | translate }}</button>
    </div>
</div>